import type { NavigationGuardNext, RouteLocationNormalized } from 'vue-router'
import { BaseAPIError } from '@previo/core'
import { toast } from '@previo/design-system'
import { Routes } from '~/router/routes'
import { usePropertyObjectKindsStore } from '~/store/property/objectKinds'

export const loadObjectKinds = async (
  to: RouteLocationNormalized,
  from: RouteLocationNormalized,
  next: NavigationGuardNext,
): Promise<void> => {
  try {
    const objectKindsStore = usePropertyObjectKindsStore()

    await objectKindsStore.load()

    if (!objectKindsStore.hasAnyRooms()) {
      return next({ name: Routes.GENERAL_NO_OBJECT_ROOMS })
    }

    return next()
  } catch (e) {
    if (e instanceof BaseAPIError) {
      toast.negative(e.message)
    }

    return next({ name: Routes.GENERAL_SELECT_PROPERTY })
  }
}
